import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
//@ts-ignore
import { KontentRichText } from '../../../types/KontentProps';

interface Props {
    code: KontentRichText;
}

const SocialShare: React.FC<Props> = ({ code }) => {
    useEffect(() => {
        let url = code.value;
        let urlString = strip_html_tags(url);
        urlString = urlString.replace('amp;', '');
        const script = document.createElement('script');
        script.src = urlString;
        script.async = true;
        script.type = 'text/javascript';
        document.head.appendChild(script);
        return () => {
            document.head.removeChild(script);
        };
    }, []);

    function strip_html_tags(str: any) {
        if (str === null || str === '') return false;
        else return str.replace(/<[^>]*>/g, '');
    }

    return <div></div>;
};
export default SocialShare;

export const fragmentSocialShare = graphql`
    fragment SocialShare on kontent_item_component___social_share {
        elements {
            code {
                value
            }
        }
    }
`;
